import React, { useState, useEffect } from "react";
import PrePicture from "./PrePicture";
import axios from "axios";
import Question from "./AutocompleteWordbank";
import Correct from "./CorrectAnswer";
import Wordsuggest from "./WordsforSelect";
import BoxAddword from "../../QuestiopnMain/ChoseWordLang";
import TextField from "@material-ui/core/TextField";

import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../../redux/action/user";
import { setEditTitle } from "../../../redux/action/Edit";
// url
import { BaseUrl } from "../../../Constant/Config";
import { useHistory } from "react-router";

export default function Wordbank(props) {
  // const pictureApi = props.item.picture.picture;
  // const answerApi = props.item.answer[0].correct_answer;
  // State
  const history = useHistory();
  const dispatch = useDispatch();
  const EditState = useSelector((state) => state.Edit);
  const user = useSelector((state) => state.user);
  const [picture, setPicture] = useState(); //sabt aks entekhab shode
  const [prePicture, setPrePicture] = useState(); //preview aks entekhab shode baraye neshan dadan
  const [wordList, setWordList] = useState([]);
  const [filterWord, setFilterWord] = useState([]);
  const [filterChangeLangFa, setLangFa] = useState([]);
  const [langBlankChoise, setLangBlankChoise] = useState("fa");
  // api content
  const [pic_id, setPic_id] = useState(); //sabt id braye ersal be server property picture
  const [questionWord, setQuestionWord] = useState();
  const [correctAnswer, setCorrectAnswer] = useState([]);
  const [answerForUser, setAnswerForUser] = useState([]);
  const [titlef, setTitlef] = useState(EditState.edit && EditState.title ? EditState.title : "");
  const [filterEn, setFilterEn] = useState()
  // words
  //  correct_awnser
  // const handleFilterWord = (words, language) => {
  //   setFilterWord(words?.filter((word) => word.language === language));
  //   setLang(language);
  // };

  //functions
  const Picturehandler = (e) => {
    if (e.target.files[0] !== undefined) {
      setPicture(e.target.files[0]);
      setPrePicture(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handletitle = (e) => {
    EditState.edit && dispatch(setEditTitle(e.target.value))
    dispatch(setTitle(e.target.value));
    setTitlef(e.target.value);
  };

  // const getWordList = () => {
  //   axios
  //     .get(
  //       `${BaseUrl}/admin/word/list?api_token=${localStorage.getItem("token")}`
  //     )
  //     .then((res) => {
  //       setWordList(res.data.data);
  //     })
  //     .catch((error) =>
  //       error?.response?.data.status === 401 ? history.push("/login") : null
  //     );
  // };
  // const handleFilterWord = (words, language) => {
  //   setFilterWord(words?.filter((word) => word.language === language));
  //   setLangBlankChoise(language);
  // };
  // const handleFilterFa = (words, language) => {
  //   setLangFa(words?.filter((word) => word.language === "fa"));
  // };
  // const handleChangeEn = (words, language) => {
  //   setFilterEn(words?.filter((word) => word.language === "en"));
  // };
  // useEffect(() => {
  //   getWordList();
  //   // handleFilterWord();
  // }, []);
  // useEffect(() => {
  // handleFilterWord(wordList);
  // handleChangeEn(wordList);
  // handleFilterFa(wordList);
  // }, []);

  return (
    <div className="Wordbank">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 title_of_questions">
            <TextField
              variant="filled"
              id="standard-basic "
              className="text_bold"
              label={<p>عنوان سوال</p>}
              onChange={handletitle}
              autoComplete="off"
              value={titlef}
            />
          </div>
          <div className="col-12 d-block d-lg-flex align-items-center ">
            <div className="d-flex align-items-center justify-content-center">
              <PrePicture
                id="Wordbank"
                pic_id={pic_id}
                setPic_id={setPic_id}
                Picturehandler={Picturehandler}
                prePicture={prePicture}
                picture={picture}
                answerinapi={props.item}
              />
            </div>
            {/* <div className="d-flex align-items-center justify-content-center "> */}
            <div>
              <div className="d-flex justify-content-center justify-content-lg-end mt-4 mt-lg-0">
                <BoxAddword setWordList={setWordList} />
              </div>
              <div className="d-flex justify-content-center align-items-center mt-3">
                <div className="mosalas d-none d-lg-block"></div>
                <div className="title_word">
                  <Question
                    setQuestionWord={setQuestionWord}
                    Words={user.WordList}
                    type="word-bank"
                    answerinapi={props.item}
                  />
                </div>
              </div>
            </div>

            {/* </div> */}
          </div>
        </div>
        <div className="row py-5">
          <div className="col-12 correct_awnser">
            <div className="px-3">
              <Correct
                setCorrectAnswer={setCorrectAnswer}
                answerinapi={props.item}
              />
            </div>
          </div>

          <div className="col-12 Wordsuggest d-flex justify-content-between align-items-center">
            <Wordsuggest
              setAnswerForUser={setAnswerForUser}
              Words={user.WordList}
              type="word-bank"
            // filterChangeLangFa={filterChangeLangFa}
            // answerinapi={props.item}
            />
          </div>
          {/* <div className="col-12 correct_awnser mt-3">
            <hr className="hr" />
          </div> */}
        </div>
      </div>
    </div>
  );
}
